import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Checkbox = ({ label, checked }) => (
  <CheckboxContainer style={{ display: 'flex' }}>
    <HiddenCheckbox checked={checked} />
    <StyledCheckbox checked={checked}>
      <Icon viewBox="0 0 24 24">
        <polyline points="20 6 9 17 4 12" />
      </Icon>
    </StyledCheckbox>
    <div style={{ marginLeft: '5px' }}>{label}</div>
  </CheckboxContainer>
);

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
};

export default Checkbox;

// const CheckboxContainer = styled.div`
//   margin: 40px;
//   color: #505d68;
//   font-size: 16px;
//   font-family: 'Karla', sans-serif;
// `;

const CheckboxContainer = styled.div`
  display: contents;
  margin: 40px;
  display: inline-block;
  vertical-align: middle;
  color: #505d68;
  font-size: 16px;
  font-family: 'Karla', sans-serif;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  // Hide checkbox visually but remain accessible to screen readers.
  // Source: https://polished.js.org/docs/#hidevisually
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const Icon = styled.svg`
  fill: none;
  stroke: #3e4a7c;
  stroke-width: 2px;
`;

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  // background: ${props => props.checked ? 'salmon' : 'papayawhip'}
  border: 1px solid #979797;
  border-radius: 3px;
  transition: all 150ms;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px pink;
  }

  ${Icon} {
    visibility: ${props => props.checked ? 'visible' : 'hidden'}
  }
`;



// WEBPACK FOOTER //
// ./client/shared/Checkbox.js